import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import { RelationRole } from "../../contracts/base/relation-role";
import { ArgumentError } from "../../errors/argument-error";

@JsonObject()
export class NestedRelationInfo {
    @JsonProperty("relation")
    relation: string;

    @JsonProperty("role")
    role: RelationRole;

    @JsonProperty("properties")
    @JsonElementType(String)
    properties: Array<string> = [];

    @JsonProperty("renditions")
    @JsonElementType(String)
    renditions: Array<string> = [];

    @JsonProperty("limit")
    limit?: number;

    constructor(init?: Partial<NestedRelationInfo>) {
        Object.assign(this, init);
    }

    static parse(values: Array<string>): Array<NestedRelationInfo> {
        if (!values || !values.length) {
            return [];
        }
        const result: Array<NestedRelationInfo> = [];
        for (const value of values) {
            if (!value || !value.length) {
                continue;
            }
            const parts = value.split(",");
            for (const part of parts) {
                if (part && part.length) {
                    result.push(NestedRelationInfo.parseEntry(part));
                }
            }
        }
        return result;
    }

    private static parseEntry(value: string): NestedRelationInfo {
        const exceptionMsg = "Invalid relation specified. Expected format: <name>|<role>[|<propertyName...>]";
        const tokens = value.split("|");
        if (tokens.length < 2 || !(tokens[1] in RelationRole)) {
            throw new ArgumentError(exceptionMsg);
        }
        let role: RelationRole;
        switch (tokens[1].toLowerCase()) {
            case "parent":
                role = RelationRole.Parent;
                break;
            case "child":
                role = RelationRole.Child;
                break;
            default:
                throw new ArgumentError(exceptionMsg);
        }
        let properties: Array<string> = [];
        if (tokens.length > 2) {
            properties = tokens[2].split(",");
        }
        const result = new NestedRelationInfo({
            relation: tokens[0],
            role,
            properties,
        });
        return result;
    }
}
